module.exports = __webpack_public_path__ + "static/media/essence-of-kernelcon-3.734b7d72.jpeg";